module.exports = __webpack_public_path__ + "static/media/interview.4085c064.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/interview.png
// module id = 574
// module chunks = 0